import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {origin,publicPages,schemaFor} from '@/data/publicSeo';
export default function PublicSeo(){
  const {pathname}=useLocation();
  useEffect(()=>{
    const path=pathname.replace(/\/$/,'')||'/';
    const page=publicPages.find(p=>p.path===path);
    const meta=(key:string,value:string,property=false)=>{
      const attr=property?'property':'name';
      let tag=document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if(!tag){tag=document.createElement('meta');tag.setAttribute(attr,key);document.head.appendChild(tag);}
      tag.content=value;
    };
    meta('robots',page?'index,follow,max-image-preview:large':'noindex,follow');
    let canonical=document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if(!canonical){canonical=document.createElement('link');canonical.rel='canonical';document.head.appendChild(canonical);}
    canonical.href=origin+path;
    document.getElementById('public-schema')?.remove();
    if(page){
      document.title=page.title;meta('description',page.description);
      meta('og:title',page.title,true);meta('og:description',page.description,true);meta('og:url',origin+path,true);
      meta('twitter:title',page.title);meta('twitter:description',page.description);
      const script=document.createElement('script');script.id='public-schema';script.type='application/ld+json';script.textContent=JSON.stringify(schemaFor(page));document.head.appendChild(script);
    }
  },[pathname]);
  return null;
}
